import { request } from '../request';

/**
 * 获取用户中心详情
 *
 * @returns
 */
export const fetchGetUserInformation = () => {
  return request<Api.UserCenter.User>({
    url: '/usercenter/api/uc/profile/information',
    method: 'get'
  });
};

/**
 * 更新用户中心信息
 *
 * @param params
 * @returns
 */
export const fetchPostUserInformation = params => {
  return request({
    url: '/usercenter/api/uc/profile/information',
    method: 'post',
    params
  });
};

/**
 * 上传文件
 *
 * @returns
 */
export const fetchPostFile = data => {
  return request({
    url: '/developer-platform/api/upload/file',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  });
};

export const fetchPostUserPassword = params => {
  return request({
    url: '/usercenter/api/uc/profile/password',
    method: 'post',
    params
  });
};

export const fetchPostUserEmailCode = params => {
  return request({
    url: '/usercenter/api/uc/profile/change/verify/email/token',
    method: 'post',
    params
  });
};

export const fetchPostUserEmail = params => {
  return request({
    url: '/usercenter/api/uc/profile/change/email/bind',
    method: 'post',
    params
  });
};
